import { IS_DEV, IS_PROD, IS_STAGING } from "../constants";

declare const CLIENT_ID: string;

export const DEV_HOST = "https://localhost:7777";
export const STAGING_HOST = "https://dev-outlook.simplelegal.io";
export const PROD_HOST = "https://outlook.simplelegal.com";

let HOST;

if (IS_DEV) {
  HOST = DEV_HOST;
} else if (IS_PROD) {
  HOST = PROD_HOST;
} else if (IS_STAGING) {
  HOST = STAGING_HOST;
} else {
  HOST = PROD_HOST;
}

export const getDomain = ({ workspace, tld, path }: { workspace: string; tld: string;  path: string }): string =>
  IS_DEV
    ? `https://local.simplelegal.${tld}:8443${path}`
    : `https://${workspace}.simplelegal.${tld}${path}`;

export const APIUrls = {
  urlForAccessToken(workspace: string, tld:string ): string {
    return getDomain({ workspace, tld, path: "/api/v1/email-client/auth/token/" });
  },
  urlForBucketCredentials(workspace: string, tld:string ): string {
    return getDomain({ workspace, tld, path: "/api/v1/email-client/bucket/" });
  },
  urlForEmailPayload(workspace: string, tld:string ): string {
    return getDomain({ workspace, tld, path: `/api/v1/email-client/matters/` });
  },
  urlForAuthorization({
    workspace,
    tld,
    codeChallenge
  }: {
    workspace: string;
    tld:string;
    codeChallenge: string;
  }): string {
    return getDomain({
      workspace,
      tld,
      path: `/api/v1/email-client/auth/authorize/?response_type=code&client_id=${Configs.clientId}&code_challenge=${codeChallenge}&code_challenge_method=S256&redirect_uri=${Configs.redirectUri}`
    });
  },
  urlForSearchMatters(workspace: string, tld:string): string {
    return getDomain({ workspace, tld, path: `/api/v1/email-client/matters/?search=` });
  },
  // TODO: Remove this defaultUrl if not necessary...
  defaultUrl: "https://eng-outlook.simplelegal.com"
};

export const Configs = {
  redirectUri: HOST,
  clientId: CLIENT_ID,
  grantType: "authorization_code",
  refreshGrantType: "refresh_token"
};

export const ImageUrls = {
  tickImage: `${HOST}/assets/registered.png`,
  simpleLegalIcon: `${HOST}/assets/icon-80.png`
};
